<div
  class="onboarding-progress"
  [class.onboarding-progress--signing]="variant === 'signing'">
  <div class="onboarding-progress__header" *ngIf="variant !== 'signing'">
    <div
      class="onboarding-progress__ring"
      [style.--progress]="normalizedProgressPercent + '%'">
      <span>{{ progressLabel }}</span>
    </div>
    <div class="onboarding-progress__step">
      <span>Current step</span>
      <strong>{{ currentStepLabel }}</strong>
    </div>
    <button
      *ngIf="showDetailsButton"
      type="button"
      class="onboarding-progress__details"
      (click)="onDetailsClick()">
      {{ detailsLabel }}
    </button>
  </div>

  <div
    *ngIf="showTimeline"
    class="onboarding-progress__timeline"
    role="list"
    [attr.id]="timelineId"
    [attr.aria-label]="ariaLabel">
    <div
      *ngFor="
        let step of steps;
        let index = index;
        let last = last;
        trackBy: trackByStep
      "
      class="onboarding-progress__timeline-step"
      [class.is-active]="isStepActive(step, index)"
      [class.is-complete]="step.isCompleted"
      [attr.aria-current]="isStepActive(step, index) ? 'step' : null"
      role="listitem">
      <span
        class="onboarding-progress__timeline-node"
        [class.is-complete]="step.isCompleted"
        [class.is-active]="isStepActive(step, index)">
        <mat-icon *ngIf="step.isCompleted" aria-hidden="true">check</mat-icon>
        <span
          *ngIf="isStepActive(step, index) && !step.isCompleted"
          class="onboarding-progress__timeline-dot"
          aria-hidden="true"></span>
        <span
          *ngIf="!step.isCompleted && !isStepActive(step, index)"
          class="onboarding-progress__timeline-number">
          {{ stepNumber(step, index) }}
        </span>
      </span>
      <span
        *ngIf="!last"
        class="onboarding-progress__timeline-line"
        [class.is-complete]="step.isCompleted"></span>
      <span class="onboarding-progress__timeline-copy">
        <span class="onboarding-progress__timeline-copy-main">
          <strong>{{ step.label || step.name }}</strong>
          <em
            *ngIf="
              isStepActive(step, index) && showActiveState && activeStateLabel
            ">
            {{ activeStateLabel }}
          </em>
        </span>
        <span
          class="onboarding-progress__timeline-state"
          *ngIf="variant === 'signing' && !step.isCompleted">
          {{
            isStepActive(step, index) ? activeStatusLabel : upcomingStatusLabel
          }}
        </span>
        <time *ngIf="step.completedAt" [attr.datetime]="step.completedAt">
          {{ step.completedAt | date : timelineDateFormat }}
        </time>
      </span>
    </div>
  </div>

  <div
    class="onboarding-progress__metadata"
    *ngIf="showMetadata && metadataDate">
    <span></span>
    <span>
      <mat-icon aria-hidden="true">calendar_today</mat-icon>
      {{ metadataDate | date : timelineDateFormat }}
    </span>
  </div>
</div>
